module.exports = ".container {\r\n  min-height: 60vh;\r\n}\r\n"